import { render, staticRenderFns } from "./orderDIFOTLateOrderListWidget.vue?vue&type=template&id=64cffc78&"
import script from "./orderDIFOTLateOrderListWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTLateOrderListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports